module.exports = __webpack_public_path__ + "static/media/Logo2.d6a55bea.svg";